import { RestClient } from "./restClient";
import { RealtimeClient } from "./RealtimeClient";

export class ListService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
		this._rc = new RealtimeClient();
	}

	// Create an original list
	createList(list, callback) {
		const url = "/ecosystem/api/list";
		const body = JSON.stringify({
			list
		});
		this._restClient.exec_post(url, body, callback);
	}

	// Update a list
	updateList(listId, list, callback) {
		const url = `/ecosystem/api/list/${listId}`;
		const body = JSON.stringify({
			list
		});
		this._restClient.exec_put(url, body, callback);
	}

	// Delete list by id
	deleteList(listId, callback) {
		const url = `/ecosystem/api/list/${listId}`;
		this._restClient.exec_delete(url, callback);
	}

	// Get list by id
	getList(listId, callback) {
		const url = `/ecosystem/api/list/${listId}`;
		this._restClient.exec_get(url, callback);
	}

	// Get all original lists user has available
	// If callback is passed, execute normally. Otherwise return promise for use with async/await.
	getAll(callback) {
		const url = "/ecosystem/api/list";
		if (callback) {
			this._restClient.exec_get(url, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_get(url, (err, result) => {
					if (err) {
						reject(err);
						return;
					}
					resolve(result);
				});
			});
		}
	}

	// Create a copy of a list or group of lists on an event
	createListsByTemplates(listIds, targetType, targetId, callback) {
		const url = "/ecosystem/api/list/template";
		const body = JSON.stringify({
			listIds,
			targetType,
			targetId
		});
		this._restClient.exec_post(url, body, callback);
	}

	// Create a copy of an original list
	cloneList(listId, update, callback) {
		const url = `/ecosystem/api/list/${listId}/clone`;
		const body = JSON.stringify({
			update
		});
		this._restClient.exec_post(url, body, callback);
	}

	streamOriginalLists(callback) {
		const args = {
			filterType: "all"
		};
		return this._rc.subscribe("ecosystem", "/list", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				if (callback) {
					callback(null, response);
				}
			}
		});
	}

	// Get all list lookup types.
	getAllListLookupTypes(callback) {
		const url = "/ecosystem/api/listLookupTypes";
		this._restClient.exec_get(url, callback);
	}

	// Stream lists associated with a target (event, alert, etc)
	streamListsByTarget(targetId, targetType, options, callback) {
		let expandRefs = false;
		if (options) {
			expandRefs = options.expandRefs || false;
		}
		const args = {
			filterType: "initial-by-target",
			targetId: targetId,
			targetType: targetType,
			expandRefs: expandRefs
		};

		return this._rc.subscribe("ecosystem", "/list", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				if (callback) {
					callback(null, response);
				}
			}
		});
	}

	// Update a pinned list
	updatePinnedList(targetId, targetType, listId, list, callback) {
		const url = `/ecosystem/api/list/${listId}/updatePinned`;
		const body = JSON.stringify({
			list,
			targetId,
			targetType
		});
		this._restClient.exec_put(url, body, callback);
	}

	// Delete a pinned list
	deletePinnedList(targetId, targetType, listId, callback) {
		const url = `/ecosystem/api/list/${listId}/deletePinned/${targetType}/${targetId}`;
		this._restClient.exec_delete(url, callback);
	}
	generateListPdf(listId, timezone, callback) {
		const url = "/lists-app/api/list/generate-pdf";
		const body = JSON.stringify({
			listId,
			timezone
		});
		this._restClient.exec_put(url, body, callback);
	}
}
